<template>
  <!-- Intentionally blank. This route exists only so Pentakill's iframe
       navbar can resolve the `location-settings-devices` named route and
       postMessage the path to OWA, which renders the Devices page natively
       (migrated out of Pentakill, see OVA-597). This component is never
       visibly shown — OWA swaps to the native page on navigation. -->
  <div />
</template>

<script>
export default {
  name: 'LocationSettingsDevices'
}
</script>

<style scoped lang="scss"></style>
